export default __webpack_public_path__ + "static/media/project.9d643f0f.png";